import _ from "lodash";
import ErrorUtils from "../../utils/errors";

export function parsePaymentServiceError(error) {
  const { data, status } = error;

  let message = ErrorUtils.getStatusCodeErrorMessage(status);
  if (data.errors) {
    if (_.isArray(data.errors)) {
      message = data.errors
        .map((err) => (_.isObject(err) ? err.message : err))
        .join(",");
    } else {
      message = _.isObject(data.errors) ? data.errors.message : data.errors;
    }
  } else {
    if (data?.error?.message) message = data.error.message;
  }
  return message;
}

export function parsePaymentServiceErrorData(error) {
  const { data } = error;

  let errorData = {}
  if (data.errors) {
    if (_.isArray(data.errors)) {
      errorData = data.errors[0]
    } else {
      errorData = data.errors;
    }
  } else {
    if (data?.error) errorData = data.error;
  }
  return errorData;
}
